import React, { useState, useCallback, useEffect } from 'react';
import { toast } from 'react-hot-toast';

import { Form } from '@unform/web';
import { Row, Col } from 'reactstrap';

import Input from '~/components/Form/Input';
import CheckboxInput from '~/components/Form/Checkbox';
import SaveButton from '~/components/Buttons/SaveButton';

import { useAuth } from '~/context/AuthContext';
import api2 from '~/services/api2';
import PermissionErrorContainer from '~/components/PermissionErrorContainer';
import { VideoPlayer } from '~/components/VideoPlayer';
import { Hyperlink, Tabs } from 'ui-kit-takeat';
import { FaCopy } from 'react-icons/fa';
import { PageTitle } from '~/components/PageTitle';
import { Container, Header, Card, ColorSwatchColor } from './styles';
import Swatch from 'components/ColorSwatch';
import DeliveryCoverInput from 'components/Form/DeliveryCoverInput';
import { Divider, Switch } from 'takeat-design-system-ui-kit';

function DeliveryConfig() {
  const { user, updateUser } = useAuth();
  const [primaryColor, setPrimaryColor] = useState(user.delivery_info?.primary_color || '');
  const [colorSelectedValue, setColorSelectedValue] = useState(primaryColor)
  const [activeTab, setActiveTab] = useState(0);
  const initialData = {
    time_to_delivery: user.delivery_info.time_to_delivery,
    time_to_withdrawal: user.delivery_info.time_to_withdrawal,
    delivery_minimum_price: user.delivery_info.delivery_minimum_price,
    client_pay_sms: user.delivery_info.client_pay_sms,
    is_sms_service_optional: user.delivery_info.is_sms_service_optional,
    is_distance_by_path: user.delivery_info.is_distance_by_path,
    auto_accept: user.delivery_info.auto_accept,
    cep_required: user.delivery_info.cep_required,
    ifood_auto_accept: user.ifood_auto_accept,
    auto_print_delivery: user.auto_print_delivery,
    withdrawal_minimum_price: user.delivery_info.withdrawal_minimum_price,
    notify_whatsapp: user.delivery_info.notify_whatsapp,
    payment_at_withdrawal: user.delivery_info.payment_at_withdrawal,
    kds_mark_ready: user.kds_mark_ready,
    use_all_kanbans: user.delivery_info.use_all_kanbans,
    use_attendance_password_asc: user.delivery_info.use_attendance_password_asc,
    use_ifood_on_demand: user.delivery_info.use_ifood_on_demand,
    delivery_promotion_modal: user.delivery_info.delivery_promotion_modal,
    primary_color: user.delivery_info?.primary_color,
    cover: {
      id: user.delivery_info?.cover_id,
      url: user.delivery_info?.cover?.url,
    },
  };

  const [permission, setPermission] = useState();
  const [loading, setLoading] = useState(false);

  const validateUser = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api2.get(
        `/restaurants/users/role-permission/${'DeliveryConfigurations'}`
      );
      setLoading(false);
      const { can_read } = response.data.DeliveryConfigurations;

      setPermission(can_read);
    } catch (error) {
      // setPermission(false);
      // if (error?.response?.data?.payload?.user_access === 'pdv') {
      //   window.location.href = '/operation';
      // }
      toast.error('Erro ao solicitar acesso');
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    validateUser();
  }, [validateUser]);

  const changeDeliveryConfig = useCallback(
    async (data) => {
      try {
        await api2.put('/restaurants/delivery-info', {
          time_to_delivery: data.time_to_delivery,
          time_to_withdrawal: data.time_to_withdrawal,
          delivery_minimum_price: data.delivery_minimum_price,
          has_sms_service: data.has_sms_service,
          is_sms_service_optional: data.is_sms_service_optional,
          client_pay_sms: data.client_pay_sms,
          notify_whatsapp: data.notify_whatsapp,
          payment_at_withdrawal: data.payment_at_withdrawal,
          is_distance_by_path: data.is_distance_by_path,
          auto_accept: data.auto_accept,
          cep_required: data.cep_required,
          withdrawal_minimum_price: data.withdrawal_minimum_price,
          use_all_kanbans: data.use_all_kanbans,
          use_attendance_password_asc: data.use_attendance_password_asc,
          use_ifood_on_demand: data.use_ifood_on_demand,
       
        });

        updateUser({
          ifood_auto_accept: data.ifood_auto_accept,
          auto_print_delivery: data.auto_print_delivery,
          kds_mark_ready: data.kds_mark_ready,
        });

       
      } catch (error) {
        toast.error('Erro ao atualizar perfil do restaurante');
      }
    },
    [updateUser]
  );
  
   const [deliveryPromotionModal, setDeliveryPromotionModal] = useState(
    user.delivery_info.delivery_promotion_modal
  );

  async function handleSubmitDeliveryConfigs(){
    try {
      await api2.put('/restaurants/delivery-info', {
        primary_color: colorSelectedValue,
        delivery_promotion_modal: deliveryPromotionModal
      })

      toast.success('Configurações atualizadas com sucesso');
    } catch (error) {
      toast.error('Erro ao atualizar perfil do restaurante');
      console.log(error)
    }
  }

  // kanban check state
  const [useAllKanbans, setUseAllKanbans] = useState(
    user.delivery_info.use_all_kanbans
  );
 

  return !permission ? (
    <PermissionErrorContainer loading={loading} />
  ) : (
    <Container>
      <Header>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <PageTitle>Configurações</PageTitle>
          <VideoPlayer id={69} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <span>Link do seu delivery: </span>
          <Hyperlink
            fontSize={14}
            onClick={() =>
              window.open(
                `https://pedido.takeat.app/${user?.nickname ? user?.nickname : user?.name
                }`
              )
            }
          >
            https://pedido.takeat.app/
            {user?.nickname ? user?.nickname : user?.name}
          </Hyperlink>
          <Hyperlink
            fontSize={14}
            onClick={() => {
              navigator.clipboard.writeText(
                `https://pedido.takeat.app/${user?.nickname ? user?.nickname : user?.name
                }`
              );
              toast.success('Link copiado com sucesso');
            }}
          >
            <FaCopy />
          </Hyperlink>
        </div>
      </Header>

      <Tabs
        containerStyles={{ zIndex: 1 }}
        tabs={['Configurações gerais', 'Personalizado']}
        onChangeTab={setActiveTab}
        selected={activeTab}
      />
      {activeTab === 0 && (
        <Card>
          <Form initialData={initialData} onSubmit={changeDeliveryConfig}>
            <Row>
              <Col lg="3">
                <Input
                  label="Tempo para retirada aprox. (min.)"
                  name="time_to_withdrawal"
                  type="number"
                  step="0.01"
                />
              </Col>
              <Col lg="3">
                <Input
                  label="Tempo para entrega aprox. (min.)"
                  name="time_to_delivery"
                  type="number"
                  step="0.01"
                />
              </Col>
              <Col lg="3">
                <Input
                  label="Preço mínimo pro pedido delivery."
                  name="delivery_minimum_price"
                  type="number"
                  step="0.01"
                />
              </Col>
              <Col lg="3">
                <Input
                  label="Preço mínimo pro pedido retirada."
                  name="withdrawal_minimum_price"
                  type="number"
                  step="0.01"
                />
              </Col>
            </Row>
            <Row>
              <h4
                style={{
                  paddingLeft: 10,
                  paddingBottom: 15,
                  paddingTop: 30,
                  textAlign: 'left',
                }}
              >
                Aviso de aceite ao cliente
              </h4>

              <Col md="12">
                <p style={{ textAlign: 'left' }}>
                  O aviso de aceite, caso ativado, permite o sistema de abrir a
                  página do whatsapp web, assim que o pedido for aceito,
                  diretamente com o numero do cliente, para que o restaurante
                  possa avisá-lo.
                </p>
              </Col>
            </Row>

            <Row>
              <Col sm="12" lg="12">
                <CheckboxInput
                  label="Ativar aviso ao cliente"
                  name="notify_whatsapp"
                />
              </Col>
            </Row>

            <Row>
              <h4
                style={{
                  paddingLeft: 10,
                  paddingBottom: 15,
                  paddingTop: 30,
                  textAlign: 'left',
                }}
              >
                Pagar na Retirada
              </h4>
              <Col md="12">
                <p style={{ textAlign: 'left' }}>
                  Se o seu estabelecimento aceita pagar pelo pedido na retirada,
                  marque a opção a baixo. A Takeat não se responsabiliza com o não
                  comparecimento do cliente nesta modalidade de pagamento.{' '}
                </p>
              </Col>
            </Row>

            <Row>
              <Col sm="12">
                <CheckboxInput
                  label="Aceita Pagar na Retirada"
                  name="payment_at_withdrawal"
                />
              </Col>
            </Row>

            <Row>
              <h4
                style={{
                  paddingLeft: 10,
                  paddingBottom: 15,
                  paddingTop: 30,
                  textAlign: 'left',
                }}
              >
                Usar trajeto para calcular a distância de entrega
              </h4>
              <Col md="12">
                <p style={{ textAlign: 'left' }}>
                  Se o seu estabelecimento usa o trajeto do restaurante até o
                  cliente no cálculo da distância, marque a opção a baixo. Será
                  usada a distância radial se esta opção estiver desmarcada.{' '}
                </p>
              </Col>
            </Row>

            <Row>
              <Col sm="12">
                <CheckboxInput
                  label="Usar o trajeto no cálculo da distância"
                  name="is_distance_by_path"
                />
              </Col>
            </Row>

            <Row>
              <h4
                style={{
                  paddingLeft: 10,
                  paddingBottom: 15,
                  paddingTop: 30,
                  textAlign: 'left',
                }}
              >
                Aceitar Pedidos Takeat Automaticamente
              </h4>
              <Col md="12">
                <p style={{ textAlign: 'left' }}>
                  Os pedidos de delivery que chegarem vão ser aceitos
                  automaticamente ao invés de ir para "Pendentes".
                </p>
              </Col>
            </Row>

            <Row>
              <Col sm="12">
                <CheckboxInput
                  label="Aceitar Pedidos Delivery Automaticamente"
                  name="auto_accept"
                />
              </Col>
            </Row>

            <Row>
              <h4
                style={{
                  paddingLeft: 10,
                  paddingBottom: 15,
                  paddingTop: 30,
                  textAlign: 'left',
                }}
              >
                Aceitar Pedidos de integração Automaticamente
              </h4>
              <Col md="12">
                <p style={{ textAlign: 'left' }}>
                  Os pedidos de plataformas externas que chegarem vão ser aceitos
                  automaticamente ao invés de ir para "Pendentes".
                </p>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <CheckboxInput
                  label="Aceitar Pedidos de integração Automaticamente"
                  name="ifood_auto_accept"
                />
              </Col>
            </Row>

            {user?.has_ifood && (
              <>
                <Row>
                  <h4
                    style={{
                      paddingLeft: 10,
                      paddingBottom: 15,
                      paddingTop: 30,
                      textAlign: 'left',
                    }}
                  >
                    Entrega Fácil iFood
                  </h4>
                  <Col md="12">
                    <p style={{ textAlign: 'left' }}>
                      Ative essa opção para solicitar motoboy do iFood via
                      'Entrega Fácil' para pedidos Takeat. Lembre-se de habilitar
                      também essa funcionalidade no portal do iFood para que o
                      serviço esteja disponível.
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <CheckboxInput
                      label="Entrega Fácil iFood"
                      name="use_ifood_on_demand"
                    />
                  </Col>
                </Row>
              </>
            )}

            <Row>
              <h4
                style={{
                  paddingLeft: 10,
                  paddingBottom: 15,
                  paddingTop: 30,
                  textAlign: 'left',
                }}
              >
                Permitir depache de pedidos pelo KDS
              </h4>
              <Col md="12">
                <p style={{ textAlign: 'left' }}>
                  Quando um pedido for finalizado no KDS, ele será movido para o
                  kanban de pedidos "Prontos" e automaticamente despachado nos
                  sistemas integrados à Takeat.
                </p>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <CheckboxInput
                  label="Permitir depache de pedidos pelo KDS"
                  name="kds_mark_ready"
                />
              </Col>
            </Row>

            <Row>
              <h4
                style={{
                  paddingLeft: 10,
                  paddingBottom: 15,
                  paddingTop: 30,
                  textAlign: 'left',
                }}
              >
                Impressão Automática de Pedidos Delivery
              </h4>
              <Col md="12">
                <p style={{ textAlign: 'left' }}>
                  Os pedidos de delivery que chegarem vão ser impressos
                  automaticamente ao serem aceitos.
                </p>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <CheckboxInput
                  label="Impressão Automática de Pedidos Delivery"
                  name="auto_print_delivery"
                />
              </Col>
            </Row>

            <Row>
              <h4
                style={{
                  paddingLeft: 10,
                  paddingBottom: 15,
                  paddingTop: 30,
                  textAlign: 'left',
                }}
              >
                Número de pedido delivery sequencial
              </h4>
              <Col md="12">
                <p style={{ textAlign: 'left' }}>
                  Ative essa opção para que os pedidos delivery Takeat recebam um
                  número sequencial. O número será resetado toda vez que o caixa
                  de qualquer usuário for fechado.
                </p>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <CheckboxInput
                  label="Número de pedido delivery sequencial"
                  name="use_attendance_password_asc"
                />
              </Col>
            </Row>

            <Row>
              <h4
                style={{
                  paddingLeft: 10,
                  paddingBottom: 15,
                  paddingTop: 30,
                  textAlign: 'left',
                }}
              >
                CEP obrigatório em Pedidos Delivery
              </h4>
              <Col md="12">
                <p style={{ textAlign: 'left' }}>
                  O cliente não poderá fazer o cadastro e finalizar o pedido sem
                  informar o CEP.
                </p>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <CheckboxInput
                  label="CEP obrigatório em Pedidos Delivery"
                  name="cep_required"
                  disabled={user.use_agilizone}
                />
              </Col>
            </Row>

            <Row>
              <h4
                style={{
                  paddingLeft: 10,
                  paddingBottom: 15,
                  paddingTop: 30,
                  textAlign: 'left',
                }}
              >
                Habilitar todos os kanbans
              </h4>
              <Col md="12">
                <p style={{ textAlign: 'left' }}>
                  Habilita o kanban com as 5 etapas.
                </p>
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <CheckboxInput
                  label="Habilitar todos os kanbans"
                  name="use_all_kanbans"
                  disabled={user.use_foody_delivery}
                  value={useAllKanbans}
                  onChange={() => setUseAllKanbans(!useAllKanbans)}
                />
              </Col>
            </Row>

            <Row>
              <Col lg="12" align="right">
                <SaveButton type="submit" />
              </Col>
            </Row>
          </Form>
        </Card>
      )}

      {activeTab === 1 && (
        <Card>
          <Form onSubmit={handleSubmitDeliveryConfigs} initialData={initialData}>
          <Row>
            <Col sm="6">
              <div>
                <h4 style={{ margin: '20px 0 0' }}>Escolha uma cor para personalizar o seu Delivery</h4>
                {primaryColor && <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
                  <span style={{fontWeight: '600', color: '#545454'}}>Cor Primária</span>
                  <ColorSwatchColor
                  // onClick={() => setColorSelected(!colorSelected)}
                  primaryColor={primaryColor}
                />
                </div>}
                
                <div style={{marginTop: 10}}>
                  <Swatch
                    colorSelectedValue={colorSelectedValue}
                    setPrimaryColor={setPrimaryColor}
                    setColorSelectedValue={setColorSelectedValue}
                  />
                </div>
              </div>
            </Col>
            <Col sm="6" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <DeliveryCoverInput name="cover" title="Inserir/ Alterar Foto" />
              </div>
          
            </Col>
          </Row>
          <Divider style={{margin: '20px 0'}}/>
          <Row>
            <h4
              style={{
                paddingLeft: 10,
                textAlign: 'left',
              }}
            >
              Mostrar tela de promoções
            </h4>
            <Col sm="12">
              <Switch
                label="Caso ative, o cliente verá a tela de promoções assim que acessar o delivery."
                name="delivery_promotion_modal"
                checked={deliveryPromotionModal}
                onChange={() =>
                  setDeliveryPromotionModal(!deliveryPromotionModal)
                }
              />
            </Col>
          </Row>
     
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <SaveButton type="submit" />
          </div>
        </Form>
        </Card>
      )}
    </Container>
  );
}

export default DeliveryConfig;
